import {Mapper} from '@s-ui/domain'

export default class FromBodyTypesListRawDataToBodyTypesListValueObjectMapper extends Mapper {
  constructor({mapper, bodyTypeValueObject, bodyTypesListValueObject}) {
    super()
    this._mapper = mapper
    this._bodyTypeValueObject = bodyTypeValueObject
    this._bodyTypesListValueObject = bodyTypesListValueObject
  }

  map = ({bodyTypes, selectedBodyType, selectedDoors}) => {
    const items = bodyTypes.map(({bodyType, doors, url}) => {
      const isSelected = bodyType === selectedBodyType && doors === selectedDoors
      return this._bodyTypeValueObject({
        bodyType,
        doors,
        url,
        ...(isSelected && {isSelected})
      })
    })
    return this._bodyTypesListValueObject({items})
  }
}
